import { Navigate } from "react-router-dom";

import { PORTAL_USER_TYPE } from "@/app/models";
import { ADMIN_ROUTES, ROUTES } from "@/app/router/constants";
import { usePortalUserStore } from "@/app/stores";

export const BaseRouter = () => {
  const portalUserType = usePortalUserStore(
    ({ portalUser }) => portalUser?.type,
  );
  const canAccessActiveWLFeatures = usePortalUserStore(
    (state) => state.canAccessActiveWLFeatures,
  );

  if (!portalUserType) {
    return <Navigate replace to={ROUTES.LOGIN} />;
  }
  if (portalUserType === PORTAL_USER_TYPE.PATIENT) {
    return <Navigate replace to={ROUTES.HOME} />;
  }
  if (portalUserType === PORTAL_USER_TYPE.COACHING) {
    if (canAccessActiveWLFeatures) {
      return <Navigate replace to={ROUTES.COACHING.OVERVIEW} />;
    }
    return <Navigate replace to={ROUTES.BILLING.OVERVIEW} />;
  }
  if (portalUserType === PORTAL_USER_TYPE.ADMIN) {
    return <Navigate replace to={ADMIN_ROUTES.COACHING.BASE} />;
  }

  return <Navigate replace to={ROUTES.HOME} />;
};
